import { Space, Tag, Typography } from 'antd';
import moment from 'moment';
import * as React from 'react';
import { MasterConfigs } from '../interfaces/entity';

const userConfigs: MasterConfigs = {
  api: () => '/users',
  title: 'Users',
  isActionTab: true,
  modalTitle: (action) => `${action} User`,
  getColumns: () => {
    return [
      {
        title: 'Employee Id',
        dataIndex: 'employeeId',
        key: 'employeeId',
        isSearch: true,
        render: (text) => `A-${text}`,
      },
      {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
        isSearch: true,
      },
      {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
        isSearch: true,
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        isRequired: true,
        isSearch: true,
      },
      {
        title: 'Gender',
        dataIndex: 'gender',
        key: 'gender',
        isSearch: true,
      },
      {
        title: 'Designation',
        dataIndex: 'role',
        key: 'role',
        render: (item) => {
          if (item) {
            return item.name;
          }
        },
      },
      {
        title: 'Account Status',
        dataIndex: 'isBlock',
        key: 'isBlock',
        render: (text) => {
          return text == 'Active' ? <Tag color="green">{'Active'}</Tag> : <Tag color="red">Blocked</Tag>;
        }
      },
      {
        title: 'Joining Date',
        dataIndex: 'dateOfJoining',
        key: 'dateOfJoining',
        isSearch: true,
        render: (text) => moment(text).format('DD MMM, YYYY'),
      },
    ];
  },
  getFormColumns: () => {
    return [
      {
        tabName: 'Basic Details',
        api: () => '/users',
        updateOrCreateAPI: '/users',
        storeObject: true,
        getChiledForm: () => [
          {
            label: 'First Name',
            name: 'firstName',
            type: 'text',
            rules: [{
              required: true,
              message: 'First Name is required'
            }]
          },
          {
            label: 'Middel Name',
            name: 'middelName',
            type: 'text',
            isRequired: false,
          },
          {
            label: 'Last Name',
            name: 'lastName',
            type: 'text',
            rules: [{
              required: true,
              message: 'Last Name is required'
            }]
          },
          {
            label: 'Gender',
            name: 'gender',
            rules: [{
              required: true,
              message: 'Gender is required'
            }],
            type: 'select',
            children: [
              { name: 'Male', value: 'Male' },
              { name: 'Female', value: 'Female' },
              { name: 'Other', value: 'Other' },
            ],
          },
          {
            label: 'Date Of Birth',
            name: 'dob',
            rules: [{
              required: true,
              message: 'Date Of Birth is required'
            }],
            type: 'date',
          },
          {
            span: 8
          },
          {
            label: 'Email',
            name: 'email',
            type: 'text',
            rules: [{
              required: true,
              message: 'Email is required'
            }],
          },
          {
            label: 'Mobile',
            name: 'mobile',
            type: 'number',
            rules: [{
              required: true,
              message: 'Mobile is required'
            }],
          },
          {
            span: 8
          },
          {
            label: 'Work Type',
            name: 'workType',
            type: 'select',
            rules: [{
              required: true,
              message: 'Work Type is required'
            }],
            children: []
          },
          {
            label: 'Number Serise',
            name: 'mobile',
            type: 'select',
            rules: [{
              required: true,
              message: 'Number Serise is required'
            }],
            children: []
          },
          {
            label: 'Employee Id',
            name: 'employeeId',
            type: 'text',
            inputProps: { disabled: true },
          },
        ],
      },
      {
        api: () => '/salaries/employee',
        updateOrCreateAPI: '/salaries',
        tabName: 'Work Type',
        getValue: (userData) => userData._id,
        getChiledForm: () => [
          {
            label: 'Date Of Joining',
            name: 'dateOfJoining',
            rules: [{
              required: true,
              message: 'Date Of Joining is required'
            }],
            type: 'date',
          },
          {
            label: 'Designation',
            name: 'role',
            rules: [{
              required: true,
              message: 'Designation is required'
            }],
            type: 'select',
            isCombo: true,
          },
          { span: 8 },
          {
            label: 'Time Type',
            name: 'timeType',
            type: 'select',
            children: [
              { name: 'Full Time', value: 'full-time' },
              { name: 'Part Time', value: 'part-time' },
              { name: 'Contractual', value: 'contractual' },
              { name: 'Internship', value: 'internship' },
              { name: 'Freelancer', value: 'freelancer' },
              { name: 'Consultant', value: 'consultant' },
            ],
            rules: [{
              required: true,
              message: 'Time type is required'
            }],
          },
          {
            label: 'Reporting Manager',
            name: 'reportingManager',
            type: 'select',
            rules: [{
              required: true,
              message: 'Reporting Manager is required'
            }],
            isCombo: true,
          },
          { span: 8 },
          {
            label: 'Legal Entity',
            name: 'legalEntity',
            type: 'select',
            children: [
              { name: 'Accel', value: 'Accel' },
              { name: 'Accel Software', value: 'Accel Software' },
              { name: 'Accel BPO', value: 'Accel BPO' },
              { name: 'Accel Consultancy', value: 'Accel Consultancy' },
            ],
            rules: [{
              required: true,
              message: 'Legal entity is required'
            }],
          },
          {
            label: 'Business Unit',
            name: 'businessUnit',
            type: 'select',
            children: [
              { name: 'Accel', value: 'Accel' },
              { name: 'Accel Software', value: 'Accel Software' },
              { name: 'Accel BPO', value: 'Accel BPO' },
              { name: 'Accel Consultancy', value: 'Accel Consultancy' },
            ],
            rules: [{
              required: true,
              message: 'Business unit is required'
            }],
          },
          {
            label: 'Department',
            name: 'department',
            type: 'select',
            isCombo: true,
            rules: [{
              required: true,
              message: 'Department is required'
            }],
          },
          {
            label: 'Location',
            name: 'location',
            type: 'select',
            children: [
              { name: 'Pune', value: 'Pune' },
              { name: 'Mumbai', value: 'Mumbai' },
              { name: 'Bangalore', value: 'Bangalore' },
              { name: 'Hyderabad', value: 'Hyderabad' },
            ],
            rules: [{
              required: true,
              message: 'Location is required'
            }],
          },
          {
            type: 'divider',
            span: 24,
            label: 'Advance',
            dividerProps: {
              orientation: 'left'
            }
          },
          {
            label: 'Probation Policy',
            name: 'probationPolicy',
            type: 'select',
            children: [
              { name: '3 Months', value: '3 Months' },
              { name: '6 Months', value: '6 Months' },
              { name: '1 Year', value: '1 Year' },
            ],
            rules: [{
              required: true,
              message: 'Probation is required'
            }],
          },
          {
            label: 'Notice Period',
            name: 'noticePeriod',
            type: 'select',
            children: [
              { name: '1 Month', value: '1 Month' },
              { name: '2 Months', value: '2 Months' },
              { name: '3 Months', value: '3 Months' },
            ],
            rules: [{
              required: true,
              message: 'Notice period is required'
            }],
          },
        ],
      },
      {
        api: () => '/salaries/employee',
        updateOrCreateAPI: '/salaries',
        tabName: 'Work Details',
        getValue: (userData) => userData._id,
        getChiledForm: () => [
          {
            // label: 'Invite Employee to login',
            name: 'inviteEmployeetoLogin',
            checkboxProps: { name: 'Invite Employee to login' },
            type: 'checkbox',
          },
          {
            // label: 'Invite Employee to login',
            name: 'enableOnboardingFlow',
            checkboxProps: { name: 'Enable onboarding flow' },
            type: 'checkbox',
          },
          {
            label: '',
            name: 'onboardingFlow',
            type: 'select',
            selectProps: { placeholder: 'Select Onboarding Flow' },
            children: [
              { name: 'Basic Details', value: 'Basic Details' },
              { name: 'Work Type', value: 'Work Type' },
              { name: 'Salary', value: 'Salary' },
              { name: 'Doccuments', value: 'Doccuments' },
            ],
          },
          {
            type: 'divider',
            span: 24,
            label: 'Time & Attandance Settings',
            dividerProps: {
              orientation: 'left'
            }
          },
          {
            label: 'Leave Plans',
            name: 'leavePlans',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            label: 'Shift Type',
            name: 'shiftType',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            label: 'Weekly Off',
            name: 'weeklyOff',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            label: 'Attendance Number',
            name: 'attendanceNumber',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            label: 'Holiday List',
            name: 'holidayList',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            type: 'divider',
            span: 24,
            label: 'Disable attendance tracking list',
            dividerProps: {
              orientation: 'left'
            }
          },
          {
            label: 'Attandance Capture Scheme',
            name: 'attandanceCaptureScheme',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            label: 'Attandance Tracking Policy',
            name: 'attandanceTrackingPolicy',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            label: 'Overtime Policy',
            name: 'overtimePolicy',
            type: 'select',
            children: [],
            rules: [{
              required: true,
              message: 'Field is required'
            }],
          },
          {
            type: 'divider',
            span: 24,
            label: 'Other Settings',
            dividerProps: {
              orientation: 'left'
            }
          },
          {
            label: 'Expense Policy',
            name: 'expensePolicy',
            rules: [{
              required: true,
              message: 'Filed is required'
            }],
            children: [],
            type: 'select',
          }
        ],
      },
      {
        api: () => '/salaries/employee',
        updateOrCreateAPI: '/salaries',
        tabName: 'Compansation',
        getValue: (userData) => userData._id,
        getChiledForm: () => [
          {
            label: '',
            name: 'enablePayroll',
            type: 'checkbox',
            checkboxProps: { name: 'Enable payroll for this employee' },
            span: 24,
          },
          {
            label: 'Pay Group',
            name: 'payGroup',
            type: 'select',
            children: [],
          },
          {
            label: 'Anual Salary',
            name: 'anualSalary',
            type: 'number',
          },
          {
            span: 24,
            type: 'divider',
            label: 'Bonus',
            dividerProps: {
              orientation: 'left'
            }
          },
          {
            label: 'Salary Increment',
            name: 'salaryIncrements',
            type: 'form',
            span: 24,
            form: [
              {
                label: 'Increase By',
                name: 'increaseBy',
                type: 'number',
                rules: [{
                  required: true,
                  message: 'Increase By is required'
                }]
              },
              {
                label: 'Increment On',
                name: 'increemntOn',
                type: 'date',
              },
            ],
          },
          {
            span: 24,
            type: 'divider',
            label: 'Payroll Settings',
            dividerProps: {
              orientation: 'left'
            }
          },
          {
            label: 'Salary Structure Type',
            name: 'salaryStructureType',
            type: 'select',
            children: []
          },
          {
            label: 'Custom Salary Structure',
            name: 'customSalaryStructure',
            type: 'select',
            children: []
          },
          {
            label: 'Tax regime to consider',
            name: 'taxRegime',
            type: 'select',
            children: []
          },
          {
            label: 'View Salary Breakup',
            name: 'pfNumber',
            type: 'text',
            inputNumberProps: { disabled: true },
          }
        ],
      },
    ];
  },
  combo: [
    {
      name: 'role',
      api: '/role',
      idKey: '_id',
      render: (e) => e.name
    },
    {
      name: 'department',
      api: '/department',
      idKey: '_id',
      render: (e) => e.name
    },
    {
      name: 'reportingManager',
      api: '/users/?includingme=yes',
      idKey: '_id',
      render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
    },
    {
      name: 'employee',
      api: '/users/employees/list',
      idKey: '_id',
      render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
    },
  ],
  getData: () => ({}),
  actions: [
    { name: 'Add User', actionType: 'Add' },
    { name: 'Return', actionType: 'Back' },
  ],
};


export default userConfigs;